module.exports = __webpack_public_path__ + "img/04.a805e1c1.webp";